// extracted by mini-css-extract-plugin
module.exports = {"bgStyleBefore":"style_bgStyleBefore__FFZ8x","bgStyleAfter":"style_bgStyleAfter__A03jP","fixed":"style_fixed__vpBOC"};